(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-holiday-snow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-holiday-snow')) {
    customElements.define('bc-holiday-snow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const button = this.querySelector('.bc-snow__toggle');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let paused = false;
        const update = () => {
          const active = !motion.matches;
          this.dataset.active = String(active);
          this.dataset.paused = String(paused);
          this.dataset.suspended = String(paused || document.hidden);
          button.hidden = motion.matches;
          button.title = button.querySelector(paused ? "span[data-snow-resume]" : "span[data-snow-pause]").textContent.trim();
        };
        button.addEventListener('click', () => {
          paused = !paused;
          update();
        }, options);
        motion.addEventListener('change', update, options);
        document.addEventListener('visibilitychange', update, options);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
